import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {CyClass} from "../../../../../common/cy-classes";
import { HistoryMoreDetailsButtonComponent } from "../../../gaming-history/record/content/history-more-details-button.component";
import {GamesOpenSessionPlayButtonBox} from "./boxes/play-button/games-open-session-play-button.box";
import {GameInfo} from "../../../../services/games/game-info";

export const GamesOpenSessionPlayButtonComponent: React.FC<{gameInfo: GameInfo}> = observer((props) => {
    const services = useServices();

    const onPlayClick = async () => {
        await props.gameInfo.open({
            isRealMode: true
        });

    }

    return (
        <GamesOpenSessionPlayButtonBox>
            <HistoryMoreDetailsButtonComponent buttonText={services.translation.translate('CONTINUE_GAME')}
                                               onClick={onPlayClick}
                                               className={CyClass('cy-open-session-play-button')}
                                               isClickable={true}
                                               notAllowedMessage={null}/>
        </GamesOpenSessionPlayButtonBox>

    );
});
